import { render, staticRenderFns } from "./DomainFormProvisioning.vue?vue&type=template&id=1f633f06&"
import script from "./DomainFormProvisioning.vue?vue&type=script&lang=ts&"
export * from "./DomainFormProvisioning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VCol,VForm,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f633f06')) {
      api.createRecord('1f633f06', component.options)
    } else {
      api.reload('1f633f06', component.options)
    }
    module.hot.accept("./DomainFormProvisioning.vue?vue&type=template&id=1f633f06&", function () {
      api.rerender('1f633f06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/domains/DomainFormProvisioning.vue"
export default component.exports